(function () {
  function normaliseColourName(value) {
    var text = value || '';
    try { text = decodeURIComponent(text); } catch (error) { /* Keep the original value. */ }
    return text.toLowerCase().replace(/[^a-z0-9]+/g, '');
  }

  function initialiseColourGallery(productInfo) {
    if (!productInfo || productInfo.dataset.colourGalleryReady === 'true') return;
    productInfo.dataset.colourGalleryReady = 'true';

    function getColourInputs() {
      return Array.from(productInfo.querySelectorAll('variant-selects [data-option-name]')).filter(function (input) {
        var optionName = (input.dataset.optionName || '').trim().toLowerCase();
        return optionName === 'color' || optionName === 'colour';
      });
    }

    function mediaColour(item, colours) {
      var searchable = Array.from(item.querySelectorAll('img')).map(function (image) {
        return [image.alt, image.currentSrc, image.src].join(' ');
      }).join(' ');
      var normalisedMedia = normaliseColourName(searchable);

      return colours.find(function (colour) {
        return normalisedMedia.indexOf(colour.key) !== -1;
      });
    }

    function filterGallery() {
      var colourInputs = getColourInputs();
      var selectedInput = colourInputs.find(function (input) { return input.checked || input.selected; });
      if (!selectedInput) return;

      var colours = [];
      colourInputs.forEach(function (input) {
        var key = normaliseColourName(input.value);
        if (key && !colours.some(function (colour) { return colour.key === key; })) {
          colours.push({ key: key, value: input.value });
        }
      });
      if (colours.length < 2) return;

      var selectedColour = normaliseColourName(selectedInput.value);
      var gallery = productInfo.querySelector('media-gallery');
      if (!gallery) return;

      var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      var slides = viewer ? Array.from(viewer.querySelectorAll('li[data-media-id]')) : [];
      var visibility = new Map();

      slides.forEach(function (slide) {
        var colour = mediaColour(slide, colours);
        var shouldHide = Boolean(colour && colour.key !== selectedColour);
        slide.hidden = shouldHide;
        slide.setAttribute('aria-hidden', shouldHide ? 'true' : 'false');
        visibility.set(slide.dataset.mediaId, !shouldHide);
      });

      var thumbnailSlider = gallery.querySelector('[id^="GalleryThumbnails-"]');
      if (thumbnailSlider) {
        thumbnailSlider.querySelectorAll('li[data-target]').forEach(function (thumbnail) {
          var colour = mediaColour(thumbnail, colours);
          var isVisible = visibility.has(thumbnail.dataset.target)
            ? visibility.get(thumbnail.dataset.target)
            : !(colour && colour.key !== selectedColour);
          thumbnail.hidden = !isVisible;
          thumbnail.setAttribute('aria-hidden', isVisible ? 'false' : 'true');
        });
      }

      productInfo.querySelectorAll('.product-media-modal__content [data-media-id]').forEach(function (modalMedia) {
        var colour = mediaColour(modalMedia, colours);
        modalMedia.hidden = Boolean(colour && colour.key !== selectedColour);
      });

      var visibleSlides = slides.filter(function (slide) { return !slide.hidden; });
      var activeSlide = slides.find(function (slide) { return slide.classList.contains('is-active'); });
      if (visibleSlides.length && (!activeSlide || activeSlide.hidden)) {
        gallery.setActiveMedia?.(visibleSlides[0].dataset.mediaId, false);
      }

      if (thumbnailSlider) thumbnailSlider.hidden = visibleSlides.length <= 1;
      var total = gallery.querySelector('.slider-counter--total');
      if (total) total.textContent = String(visibleSlides.length);
      viewer?.resetPages?.();
      thumbnailSlider?.resetPages?.();
    }

    var filterTimer;
    function queueFilter() {
      window.clearTimeout(filterTimer);
      filterTimer = window.setTimeout(filterGallery, 30);
    }

    productInfo.addEventListener('change', queueFilter);
    new MutationObserver(queueFilter).observe(productInfo, { childList: true, subtree: true });
    filterGallery();
  }

  function initialise(root) {
    root.querySelectorAll('product-info').forEach(initialiseColourGallery);

    root.querySelectorAll('[data-exclusive-accordion]:not([data-ready])').forEach(function (group) {
      group.dataset.ready = 'true';
      group.querySelectorAll('details').forEach(function (item) {
        item.addEventListener('toggle', function () {
          if (!item.open) return;
          group.querySelectorAll('details[open]').forEach(function (other) {
            if (other !== item) other.open = false;
          });
        });
      });
    });

    root.querySelectorAll('.playsphere-delivery:not([data-ready])').forEach(function (checker) {
      checker.dataset.ready = 'true';
      var input = checker.querySelector('input');
      var button = checker.querySelector('[data-delivery-check]');
      var result = checker.querySelector('.playsphere-delivery__result');
      input.addEventListener('input', function () {
        input.value = (input.value || '').replace(/\D/g, '').slice(0, 6);
        button.disabled = input.value.length !== 6;
      });
      button.addEventListener('click', function () {
        var value = (input.value || '').replace(/\D/g, '');
        if (value.length !== 6) {
          result.textContent = 'Please enter a valid 6-digit pincode.';
          input.focus();
          return;
        }
        result.textContent = 'Delivery availability and estimated arrival will be confirmed at checkout.';
      });
    });

    root.querySelectorAll('.playsphere-purchase:not([data-total-ready])').forEach(function (purchase) {
      purchase.dataset.totalReady = 'true';
      var productInfo = purchase.closest('product-info');
      var quantity = purchase.querySelector('.quantity__input');
      var button = purchase.querySelector('[name="add"]');
      var label = button && button.querySelector(':scope > span:first-child');
      var priceData = purchase.querySelector('[data-playsphere-variant-prices]');
      var variants = [];
      try { variants = priceData ? JSON.parse(priceData.textContent) : []; } catch (error) { variants = []; }

      function updateTotal() {
        if (!label || !button || button.disabled) return;
        var variantInput = purchase.querySelector('.product-variant-id');
        var selected = variants.find(function (variant) { return String(variant.id) === String(variantInput && variantInput.value); });
        var unitPrice = selected ? selected.price / 100 : 0;
        var total = unitPrice * Math.max(1, Number.parseInt(quantity.value, 10) || 1);
        label.textContent = 'Add to cart · ' + new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(total);
      }

      if (quantity) quantity.addEventListener('input', updateTotal);
      purchase.querySelectorAll('.quantity__button').forEach(function (control) {
        control.addEventListener('click', function () { window.setTimeout(updateTotal, 20); });
      });
      if (productInfo) productInfo.addEventListener('change', function () { window.setTimeout(updateTotal, 400); });
      updateTotal();
    });

    root.querySelectorAll('[data-sticky-cart]:not([data-ready])').forEach(function (bar) {
      bar.dataset.ready = 'true';
      var productInfo = bar.closest('product-info');
      var stickyButton = bar.querySelector('[data-sticky-submit]');
      var variantText = bar.querySelector('.playsphere-sticky-cart__variant');
      var priceText = bar.querySelector('.playsphere-sticky-cart__price');

      function updateBar() {
        var mainButton = productInfo && productInfo.querySelector('.product-form__submit');
        var selected = productInfo && productInfo.querySelector('variant-selects input[type="radio"]:checked + label strong');
        var quantity = productInfo && productInfo.querySelector('.playsphere-purchase .quantity__input');
        var price = productInfo && productInfo.querySelector('[id^="price-"] .playsphere-price-value');
        if (selected) variantText.textContent = (quantity ? quantity.value : '1') + ' × ' + selected.textContent.trim() + '-piece pack';
        if (price) {
          var amount = Number.parseFloat(price.textContent.replace(/[^0-9.,]/g, '').replace(/,/g, '')) || 0;
          priceText.textContent = new Intl.NumberFormat('en-IN', { style: 'currency', currency: 'INR', maximumFractionDigits: 0 }).format(amount * Math.max(1, Number.parseInt(quantity && quantity.value, 10) || 1));
        }
        if (mainButton) {
          stickyButton.disabled = mainButton.disabled;
          stickyButton.textContent = mainButton.querySelector('span') ? mainButton.querySelector('span').textContent.trim() : 'Add to cart';
        }
      }

      stickyButton.addEventListener('click', function () {
        var mainButton = productInfo && productInfo.querySelector('.product-form__submit');
        if (mainButton && !mainButton.disabled) mainButton.click();
      });
      if (productInfo) productInfo.addEventListener('change', function () { window.setTimeout(updateBar, 350); });
      updateBar();
    });
  }

  document.addEventListener('DOMContentLoaded', function () { initialise(document); });
  document.addEventListener('shopify:section:load', function (event) { initialise(event.target); });
})();
